import type { ComponentType, FC } from "react";
import type { Moment } from "moment";
import type { BoxProps } from "@mui/material/Box";
import type { BooleanSwitch } from "types";
import type { Setup } from "features/setups/types";
import type { SerializableValue } from "ui/widgets/Filters";
import type { SetupFormReturnType } from "../types";

export type JsonAssocValue = object | string;

export type CsvValue = Array<string>;

export type StringValue = string;

export type IntValue = number;

export type NumberValue = number;

export type BooleanValue = BooleanSwitch;

export type DateTimeValue = Moment | null;

export type CsvCountryValue = Array<string>

export interface ISetupValue<T extends unknown> extends SerializableValue<T> {
    value: T;
    deserialize(setupValue: Setup<string>['setupValue']): T;
    update(value: T): this;
};

export abstract class BaseSetupValue<T extends unknown> implements ISetupValue<T> {
    public value: T;

    public constructor({ setupValue }: Setup<string>) {
        this.value = this.deserialize(setupValue);
    }

    public update(value: T) {
        this.value = value;
        return this;
    }

    public abstract deserialize(setupValue: Setup<string>['setupValue']): T;

    public abstract serialize(): string;
}

export type SetupValueProps<T extends unknown = unknown> =
    & SetupFormReturnType<T>
    & Partial<{
        readonly sx: BoxProps['sx'];
        readonly onChange: (value: T) => void;
        readonly registry: Map<
            Setup<string>['valueType'],
            [
                ComponentType<SetupFormReturnType<unknown>>,
                new (setup: Setup<string>) => ISetupValue<unknown>
            ]
        >;
    }>;

export interface SetupValueFunctionComponent extends FC<SetupValueProps> {};
